module.exports = __webpack_public_path__ + "img/chart.43f54dcc.png";